module.exports = __webpack_public_path__ + "img/SKMA_smoke3.e7985598.png";